import { X } from "lucide-react";

interface FieldClearProps {
  show: boolean;
  onClear: () => void;
  className?: string;
}

export default function FieldClear({ show, onClear, className = "right-2" }: FieldClearProps) {
  if (!show) return null;
  return (
    <button
      type="button"
      tabIndex={-1}
      onClick={(e) => { e.preventDefault(); onClear(); }}
      className={`absolute z-10 top-1/2 -translate-y-1/2 p-1 rounded-md text-neutral-400 hover:text-neutral-800 hover:bg-neutral-100 transition ${className}`}
      aria-label="Očisti polje"
    >
      <X className="size-3.5 stroke-[2.5]" />
    </button>
  );
}
